var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-table-column", {
    attrs: { "class-name": "minus" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(scope) {
          return [
            _vm.addRowMode
              ? [
                  _c(
                    "el-col",
                    { staticClass: "delete-row" },
                    [
                      _vm.deletable(
                        _vm.addRowMode,
                        _vm.deleteCase,
                        _vm.tableDataCount,
                        scope.$index
                      )
                        ? _c("el-button", {
                            attrs: {
                              type: "danger",
                              circle: "",
                              icon: "el-icon-minus"
                            },
                            on: {
                              click: function($event) {
                                return _vm.clickDeleteRow(scope.$index)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }